module.exports = __webpack_public_path__ + "static/media/landingGui.4db16e1a.svg";